"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dialog = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../../provider/ProfileProvider");

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Quick fix: Lazy load at least the matching
var StaticView = /*#__PURE__*/_react.default.lazy(function () {
  return import(
  /* webpackChunkName: 'matchingStaticView' */
  '@jobmatchme/pc-matching/es/components/StaticView');
});

var Dialog = function Dialog(_ref) {
  var _renderedProfile$name;

  var field = _ref.field,
      setIsDialogOpen = _ref.setIsDialogOpen,
      _ref$isDialogOpen = _ref.isDialogOpen,
      isDialogOpen = _ref$isDialogOpen === void 0 ? false : _ref$isDialogOpen,
      discriminator = _ref.discriminator,
      t = _ref.t;
  var profile = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  var renderedProfile = (0, _ProfileProvider.stripProfileOfValueTypes)(profile);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.default, {
    id: 'questionDialog',
    title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      align: "center",
      className: _styleModule.default.dialogTitle,
      children: t("".concat(field.title))
    }),
    verticalMobilePosition: 'bottom',
    onClose: function onClose() {
      return setIsDialogOpen(false);
    },
    showDividers: true,
    open: isDialogOpen,
    opacity: 0.5,
    dialogActions: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      container: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        alignContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          align: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            color: field.color,
            variant: "contained",
            round: true,
            flat: true,
            extraBold: true,
            texttransform: "none",
            onClick: function onClick() {
              return setIsDialogOpen(false);
            },
            className: _styleModule.default.dialogBtn,
            children: t("".concat(field.btn))
          })
        })
      })
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      container: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        alignContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {}),
          children: isDialogOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(StaticView, (0, _extends2.default)({
            discriminator: discriminator,
            displayName: renderedProfile === null || renderedProfile === void 0 ? void 0 : (_renderedProfile$name = renderedProfile.names) === null || _renderedProfile$name === void 0 ? void 0 : _renderedProfile$name.matching,
            joboffer: renderedProfile
          }, field.pcData))
        })
      })
    })
  }, field.type);
};

exports.Dialog = Dialog;

var _default = /*#__PURE__*/(0, _react.memo)(Dialog);

exports.default = _default;